import React, { useEffect, Suspense } from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { styled } from "@mui/material/styles";
import Header from "../components/Header";
import { Outlet, useLocation } from "react-router-dom";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Layout = () => {

  const location = useLocation();
  return (
    <>
      <Box sx={{ display: "flex" }}>
        <Header locPath={location} />
        <Box component="main" sx={{ flexGrow: 1 }}>
          <DrawerHeader />
          <Suspense fallback={
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
              <CircularProgress />
            </Box>
          }>
            <Outlet />
          </Suspense>
        </Box>
      </Box>
    </>
  );
};

export default Layout;
